export enum SourceType {
  AD_MANAGER = 'AD_MANAGER',
  ADMOB = 'ADMOB',
  YIELDMO = 'YIELDMO',
}
